import { Inject } from '@odinjs/odin';

import { catchRenderException, DialogServiceAccreditation, Endpoint, Return, Route, ToastServiceProviderAccreditation } from '@philips-emr/hpms-provider-accreditation-commons';
import { ButtonAPI, FieldAPI, FormAPI, InputAPI, PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnClick, OnValidate } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, ValidateEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';

import BaseController from '../BaseController';

interface MyDataFetch {
  dsMessageFinal?: string,
  dsMessageCnesStart?: string,
  dsMessageCnesProcess?: string,
  message?: string
}

interface MyGenerateResponse {
  outParameters: {
    nr_seq_credenciamento_p: number;
  }
}

@Controller({ fragment: 'provider-accreditation-cnes' })
export default class ProviderAccreditationCnesController extends BaseController {

  @Inject('form-cnes')
  private formCnes!: FormAPI;

  @Inject('field-message-cnes')
  private fieldMessageCnes!: FieldAPI;

  @Inject('field-cnes')
  private fieldCnes!: FieldAPI;

  @Inject('input-cnes')
  private inputCnes!: InputAPI;

  @Inject('start-action')
  private startAction!: ButtonAPI;

  @Inject('panel-start')
  private panelStart!: PanelAPI;

  @OnAfterFetch('fetch-cnes')
  OnAfterFetchList(event: FetchEvent): void {
    void this.handlerCnes(event);
  }

  private async handlerCnes(event: FetchEvent): Promise<void> {
    const { nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    const { dsMessageCnesStart, dsMessageCnesProcess } = event.data as MyDataFetch;
    let message!: any;

    if (!nrSeqAccreditation) {
      this.panelStart.setVisible(true);
      message = dsMessageCnesStart;
    }

    if (nrSeqAccreditation) {
      const response = await this.getStatusAccreditation();
      const { cdCnes } = response.body;
      catchRenderException(() => {
        this.fieldCnes.setState({ showValidations: false });
        this.inputCnes.setReadOnly(true);
        this.inputCnes.setValue(cdCnes);
        message = dsMessageCnesProcess;
      });
    }
    catchRenderException(() => {
      this.fieldMessageCnes.setValue(message);
    });
  }

  @OnClick('start-action')
  onSaveActionClick(): void {
    this.generateAccreditation();
  }

  @OnValidate('form-cnes')
  onValidateForm(event: ValidateEvent): void {
    const { valid } = event;
    catchRenderException(() => this.startAction.setEnabled(valid));
  }

  private generateAccreditation(): void {

    this.startAction.setState({ loading: true });
    const { cdCnes } = this.formCnes.getRecord();
    this.context.set({ cdCnes: cdCnes });
    const { nrSeqUser, nrSeqTypeAccreditation } = this.historyService.getCurrentRouteParams();
    const ieTypeApplication = 'pro';
    HttpService.post(Endpoint.POST.GENERATE_ACCREDITATION, { nrSeqUser, nrSeqTypeAccreditation, cdCnes, ieTypeApplication })
      .then((response) => {
        const { message } = response?.body as MyDataFetch;
        if (message) {
          this.startAction.setState({ loading: false });
          const messageReplaced = message.replace('#@CD_CNES#@', String(cdCnes));
          DialogServiceAccreditation.alert(messageReplaced);
        } else {
          this.startAction.setState({ loading: false });
          const { outParameters: { nr_seq_credenciamento_p: nrSeqAccreditation } } = response.body as MyGenerateResponse;
          this.historyService.push(Route.DETAIL_PROVIDER_ACCREDITATION, { nrSeqUser, nrSeqAccreditation, nrSeqTypeAccreditation });
        }
      }).catch(() => {
        ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request'));
        this.startAction.setState({ loading: false });
      });
  }

  private getStatusAccreditation(): Promise<any> {
    const { nrSeqUser, nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    return HttpService.get<Return<string>>(Endpoint.GET.ACCREDITATION_STATUS, { nrSeqUser, nrSeqAccreditation });
  }
}
